import Vue from 'vue'
import VuetifyAlgoliaPlaces from 'vuetify-algolia-places'

Vue.use(VuetifyAlgoliaPlaces, {
  algolia: {
    appId: process.env.VUE_APP_ALGOLIA_APPID,
    apiKey: process.env.VUE_APP_ALGOLIA_API_KEY,
  },
})
